<div class="funil-venda-select dropdown"
    [class.with-title]="isShowTitle">
    <button class="btn btn-light dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"
        [disabled]="disabled">

        <small class="funil-venda-select-title" *ngIf="isShowTitle">
            Funil de Venda
        </small>

        <span class="funil-venda-select-label">
            <img src="../../../../../assets/img/crm/funil-venda/funil-venda.png" alt="Funil de Venda">
            <span *ngIf="funilVenda">
                {{funilVenda.nome}}
            </span>
            <span *ngIf="!funilVenda">
                Nenhum Funil de Venda
            </span>
        </span>

    </button>
    
    <div class="dropdown-menu-container">
        <div class="dropdown-menu">
            <div class="dropdown-menu-itens">
                <a class="dropdown-item" 
                    *ngIf="isShowNull"
                    [class.dropdown-item-select]="!idFunilVenda"
                    (click)="select(null)">
                    Nenhum Funil de Venda
                </a>
                <a *ngFor="let funil of search?.funisVendas" 
                    class="dropdown-item"
                    [class.dropdown-item-select]="funil.id == idFunilVenda"
                    (click)="select(funil)">
                    {{funil.nome}}
                </a>
            </div>
        </div>        
    </div>
</div>